import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Body, Title } from '@vds/typography';
import { Button } from '@vds/buttons';
import { convertStringToElements } from '@vds/html-parsers';
import { Col, Row } from '../../../../../common/Grid';
import AddonTile from './addonTile';
import AddonCarousel from './addonsCarousel';
import { isMobile, isYoutubePremiumSelected } from '../../../../../common/Helpers';
import { getAddonData } from './addonsCommon';
import CommonModal from '../../../../../common/Modal';
import { StyledVdsRow } from '../../../../../common/styles';

const StreamingServices = (props) => {
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [addonModalData, setAddonModalData] = useState({});
  const [showPromoDetailsModal, setShowPromoDetailsModal] = useState(false);
  const { refData, accessory = [] } = props;
  const isYoutubePremiumAdded = isYoutubePremiumSelected();
  if (!refData?.length) {
    return null;
  }

  const prepareTileData = (service) => {
    if (!service || !service.skuDetails) {
      return {};
    }
    const { skuDetails, type, recurringInd, pricePlanId } = service;
    const tileData = getAddonData(service, refData);
    const removeAddon = () => props.removeAddon(refData, skuDetails, tileData.title, type, recurringInd, pricePlanId);
    const addAddon = () => props.addAddon(refData, props.notifyMessage, skuDetails, type, tileData.title, recurringInd, pricePlanId);
    return {
      ...props,
      ...tileData,
      isYoutubePremiumAdded,
      addAddon,
      removeAddon,
      detailsLinkListener: () => {
        setAddonModalData(tileData);
        setShowDetailsModal(true);
      },
      setShowPromoDetailsModal: (val) => {
        setAddonModalData(tileData);
        setShowPromoDetailsModal(val);
      },
    };
  };
  const tileData = accessory?.map((service) => prepareTileData(service));
  const getModalBody = (bodyContent = []) =>
    bodyContent?.map(({ subheader, description, note }) => (
      <>
        {subheader && <Title bold primitive="h3">{convertStringToElements(subheader)}</Title>}
        {description && (
          <>
            <Title size="small" primitive="p">
              {convertStringToElements(description)}
            </Title>
            {!note && <br />}
          </>
        )}
        {note && (
          <>
            <Body size="small" color="#6F7171">
              {convertStringToElements(note)}
            </Body>{' '}
            <br />
          </>
        )}
      </>
    ));

  const getModalFooter = () => (
    <Button
      size="large"
      use="primary"
      onClick={() => {
        setShowDetailsModal(false);
        setAddonModalData({});
      }}
    >
      Close
    </Button>
  );
  return (
    <>
      {isMobile() && accessory?.length > 1 ? (
        <>
          <AddonCarousel data={tileData} renderItem={(carouselProps) => <AddonTile {...carouselProps} />} />
          {isYoutubePremiumAdded && (
              <div>
                <Body color="#6F7171">
                <span className="fontSize_11">&sup1; {props?.superscript1Content}</span>
                </Body>
              </div>
            )}
            </>
      ) : (
        <>
          <Row>
            {accessory?.map((service) => (
              <Col key={service?.prodId} colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}>
                <AddonTile {...prepareTileData(service)} />
              </Col>
            ))}
          </Row>
          <StyledVdsRow mTop="25px">
            <Col>
              {isYoutubePremiumAdded && (
                <div>
                  <Body color="#6F7171">
                  <span className="fontSize_11">&sup1; {props?.superscript1Content}</span>
                  </Body>
                </div>
              )}
            </Col>
          </StyledVdsRow>
        </>
      )}
      {showDetailsModal && addonModalData && (
        <CommonModal
          opened={showDetailsModal}
          onOpenedChange={(newState) => {
            if (!newState) {
              setShowDetailsModal(false);
            }
          }}
          modalTitle={addonModalData.detailModalHeader}
          modalBody={isYoutubePremiumAdded ? getModalBody(addonModalData?.promoDetailModalBody) : getModalBody(addonModalData?.detailModalBody)}
          modalFooter={getModalFooter()}
          ariaLabel="View details"
        />
      )}
      {showPromoDetailsModal && (
        <CommonModal
          opened={showPromoDetailsModal}
          onOpenedChange={(newState) => {
            if (!newState) {
              setShowPromoDetailsModal(false);
            }
          }}
          modalTitle={convertStringToElements(addonModalData?.promoBannerDetailsModalHeader || '')}
          modalBody={convertStringToElements(addonModalData?.promoBannerDetailsModalContent || '')}
          ariaLabel="View details"
          modalFooter={
            <Button
              size="large"
              use="primary"
              width="100%"
              onClick={() => {
                setShowPromoDetailsModal(false);
              }}
            >
              Got it
            </Button>
          }
        />
      )}
    </>
  );
};

StreamingServices.propTypes = {
  refData: PropTypes.array.isRequired,
  accessory: PropTypes.array.isRequired,
  removeAddon: PropTypes.func.isRequired,
  services: PropTypes.array.isRequired,
  addAddon: PropTypes.func.isRequired,
  notifyMessage: PropTypes.string.isRequired,
  taxesAndEqpContent: PropTypes.string,
  superscript1Content: PropTypes.string,
};

export default StreamingServices;
